// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import { handleActions } from 'redux-actions';
import { UserInfoType } from '../user';
import {
    GET_ALL_USERS_SUCCESS,
    GET_SOLD_TO_SHIP_TO_SUCCESS,
    GET_ROLES_SUCCESS,
    GET_CHANNELS_SUCCESS,
    GET_TIERS_SUCCESS,
    POST_USER_SUCCESS,
    DELETE_USER_SUCCESS,
    CLEAR_USER_MESSAGE,
    CLEAR_TIERS,
} from './actions';

export interface SoldToShipToType {
    soldtoCustomerNbr: string;
    soldtoCustomerName: string;
    shiptoCustomerNbr: string;
    shiptoCustomerName: string;
}

export interface RolesType {
    roleId: number;
    roleName: string;
}

export interface ChannelsType {
    channelId: number;
    channelName: string;
}

export interface TiersType {
    tierId: number;
    tierName: string;
    channelId: number;
    channelName: string;
    isDefault: boolean;
}

export const INITIAL_STATE: {
    users: UserInfoType[] | {};
    soldToShipTo: SoldToShipToType[];
    roles: RolesType[];
    channels: ChannelsType[];
    tiers: TiersType[];
    userCreation: any;
    userDeletion: any;
} = {
    users: [],
    soldToShipTo: [],
    roles: [],
    channels: [],
    tiers: [],
    userCreation: undefined,
    userDeletion: undefined,
};

export type ManageUsersStoreType = Readonly<typeof INITIAL_STATE>;

export default handleActions(
    {
        [GET_SOLD_TO_SHIP_TO_SUCCESS]: _getSoldToShipTo,
        [GET_ALL_USERS_SUCCESS]: _getUsers,
        [GET_ROLES_SUCCESS]: _getRoles,
        [GET_CHANNELS_SUCCESS]: _getChannels,
        [GET_TIERS_SUCCESS]: _getAllTiers,
        [CLEAR_TIERS]: _clearTiers,
        [POST_USER_SUCCESS]: _postUser,
        [DELETE_USER_SUCCESS]: _deleteUser,
        [CLEAR_USER_MESSAGE]: _postUser,
    },
    INITIAL_STATE
);

function _getUsers(
    state: ManageUsersStoreType,
    { payload }: { payload: any }
): ManageUsersStoreType {
    if (payload) {
        return { ...state, users: payload };
    }
    return state;
}

function _getSoldToShipTo(
    state: ManageUsersStoreType,
    { payload }: { payload: any }
): ManageUsersStoreType {
    if (payload) {
        return { ...state, soldToShipTo: payload };
    }
    return state;
}

function _getRoles(
    state: ManageUsersStoreType,
    { payload }: { payload: any }
): ManageUsersStoreType {
    if (payload) {
        return { ...state, roles: payload };
    }
    return state;
}

function _getChannels(
    state: ManageUsersStoreType,
    { payload }: { payload: any }
): ManageUsersStoreType {
    if (payload) {
        return { ...state, channels: payload };
    }
    return state;
}

function _getAllTiers(
    state: ManageUsersStoreType,
    { payload }: { payload: any }
): ManageUsersStoreType {
    if (payload) {
        return { ...state, tiers: payload };
    }
    return state;
}

function _clearTiers(
    state: ManageUsersStoreType,
    { payload }: { payload: any }
): ManageUsersStoreType {
    return { ...state, tiers: [] };
}

function _postUser(
    state: ManageUsersStoreType,
    { payload }: { payload: any }
): ManageUsersStoreType {
    return { ...state, userCreation: payload };
}

function _deleteUser(
    state: ManageUsersStoreType,
    { payload }: { payload: any }
): ManageUsersStoreType {
    return { ...state, userDeletion: payload };
}